import createForm from './createForm';
import createNestedFormControl from './createNestedFormControl';
import FormError from './FormError';
import FormGroup from './FormGroup';
import FormSubmit from './FormSubmit';
import FormSubmitButton from './FormSubmitButton';
import FormSubmitError from './FormSubmitError';

export { createForm, createNestedFormControl, FormError, FormGroup, FormSubmit, FormSubmitButton, FormSubmitError };

const Form2 = {
  createForm,
  createNestedFormControl,
  FormError,
  FormGroup,
  FormSubmit,
  FormSubmitButton,
  FormSubmitError,
};

export default Form2;
